/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../../Common/DataTableFilter";
import { useNavigate } from "react-router-dom";
import { WebSocketContext } from "../../../App";
import { CREATE_USER_MANAGEMENT_URL } from "../../Shared/constant";
import { ClearFormSetFutios, getUserDetails } from "../../../redux/actions/adminActions";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../../Common/CommonTable";

const User = (props) => {
    const { userList, device_id, ClearFormSet, selfInfo } = useSelector((state) => state.adminReducers);
    const { websocket } = useContext(WebSocketContext);
    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ userTeamFilter, setUserTeamFilter ] = useState("");
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // get product list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.AdminTools[0]?.Edit || PermissionsAccess?.AdminTools[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "region_list",
                "request" : { 
                    "status" : "", 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "search" : ""
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // get product list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.AdminTools[0]?.Edit || PermissionsAccess?.AdminTools[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "warehouse_list",
                "request" : { 
                    "status" : "", 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "search" : ""
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

     // get all franchise list
     useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.AdminTools[0]?.Edit || PermissionsAccess?.AdminTools[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "franchise_list",
                "request" : { 
                    "status" : true, 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "search" : ""
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.AdminTools[0]?.Edit || PermissionsAccess?.AdminTools[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "user_list",
                "request" : { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "user_type" : userTeamFilter,
                    "search" : userSearch.trim()
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    };
    
    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userSearch, userType, currentPage, userLimit, userTeamFilter ]);

    useEffect(() => {
        if(ClearFormSet?.action === 200) {
            Dispatch(ClearFormSetFutios({
                url:"",
                action:false
            }));
            Dispatch(getUserDetails({}));
        };
    }, [ ClearFormSet ]);

    // create applications
    const cmnFnct = () => {
        Navigate(CREATE_USER_MANAGEMENT_URL);
    };

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'full_name', label: 'Name', type: "label_self", sort: "", isCollapsable: false },
        { key: 'user_type', label: 'User Type', type: "label_user_type", sort: "", isCollapsable: false },
        { key: 'region_id', label: 'Region', type: "label_region_name", sort: "", isCollapsable: false },
        { key: 'email', label: 'Email', type: "label", sort: "", isCollapsable: false },
        { key: 'mobile', label: 'Mobile', type: "label", sort: "", isCollapsable: false },
        { key: 'user_verification', label: 'User Verification', type: "status_user_verification_active", sort: "", isCollapsable: false },
        { key: 'is_active', label: 'Status', type: "status_active", sort: "", isCollapsable: false },
    ];

    useEffect(() => {
        Dispatch(getUserDetails({}));
    }, []);

    return(<section className="Main_section">
        <DataTableFilter 
            filterType={"Users"}
            searchType={"Name, Email, Mobile"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            userTeamFilter={userTeamFilter} 
            setUserTeamFilter={setUserTeamFilter}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.AdminTools[0]?.Edit) ? true : false}
            ButtonSet={{
                buttontitle: "Create User",
                function: cmnFnct
            }}
            searchdisable={true}
            ActiveInactiveFilter={true}
        />
        {/* COMMON TABLE */}
        <CommonTable
            isTableAllow={true} 
            style={{
                height: parseInt(userList?.pagination?.total_records) === userList?.list?.length ? "calc(100vh - 140px)" : parseInt(userList?.pagination?.total_records) > 10 ? "calc(100vh - 175px)" : "calc(100vh - 140px)"
            }}
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={"user-list"} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={userList} // CATEGORY LIST
            Pagination={userList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.AdminTools[0]?.Edit)} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.AdminTools[0]?.Edit,
                label: "edit_user_management",
                naviagte: `/edit-user/`
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default User;